import { UtilityFunctions } from 'components/wafer-control-map/utility';
import { ActionOnWaferData } from '../../wafer-map/web-gl-utils/Enums';
import { RectCoord } from '../../wafer-map/web-gl-utils/Types';
import WaferUtils from '../Utils/WaferUtils';
import { InteractionType } from './Events';

// Track the previous drag range so we can remove old temporary dies
let prevArrayIndices: RectCoord | null = null;

export const addDieMouseMove = (
  startX: number,
  startY: number,
  endX: number,
  endY: number,
  waferUtil: WaferUtils,
  isMouseDown: boolean,
  data?: { [key: string]: any },
) => {
  if (data && data.interactionType !== InteractionType.AddDie) return;
  if (!waferUtil.waferMapVariables.isAddDieControlActive) return;
  if (
    waferUtil.waferMapVariables.pageNumber !== undefined
    && waferUtil.waferMapVariables.plotterPageNumber !== undefined
    && waferUtil.waferMapVariables.pageNumber !== waferUtil.waferMapVariables.plotterPageNumber
  ) return;

  const {
    startRow, startCol, rowDirection, colDirection, waferData,
  } = waferUtil.waferMapVariables;

  if (!isMouseDown) {
    // No drag preview when just hovering - clean up any leftover temporary dies
    if (prevArrayIndices) {
      UtilityFunctions.removeTemporaryDiesForSelection(
        prevArrayIndices, startRow, startCol, rowDirection, colDirection, waferData,
      );
      prevArrayIndices = null;
      waferUtil.renderWafer();
    }
    return;
  }

  // Dragging: compute rectangular range from drag start to current position
  const arrayIndices = waferUtil.getBoxArrayIndicesFromCanvasCoords({
    startX,
    startY,
    endX,
    endY,
  });

  // Check if drag range changed
  if (
    prevArrayIndices
    && prevArrayIndices.startX === arrayIndices.startX
    && prevArrayIndices.startY === arrayIndices.startY
    && prevArrayIndices.endX === arrayIndices.endX
    && prevArrayIndices.endY === arrayIndices.endY
  ) {
    return; // No change
  }

  // Remove previous temporary dies
  if (prevArrayIndices) {
    UtilityFunctions.removeTemporaryDiesForSelection(
      prevArrayIndices, startRow, startCol, rowDirection, colDirection, waferData,
    );
  }

  // Create new temporary dies for the current drag range
  UtilityFunctions.createTemporaryDiesForSelection(
    arrayIndices, startRow, startCol, rowDirection, colDirection, waferData,
  );

  prevArrayIndices = { ...arrayIndices };
  waferUtil.renderWafer();
};

export const addDieMouseUp = (
  startX: number,
  startY: number,
  endX: number,
  endY: number,
  waferUtil: WaferUtils,
) => {
  if (!waferUtil.waferMapVariables.isAddDieControlActive) return;
  if (
    waferUtil.waferMapVariables.pageNumber !== undefined
    && waferUtil.waferMapVariables.plotterPageNumber !== undefined
    && waferUtil.waferMapVariables.pageNumber !== waferUtil.waferMapVariables.plotterPageNumber
  ) return;

  const {
    startRow, startCol, rowDirection, colDirection, waferData,
  } = waferUtil.waferMapVariables;

  // Get the array indices for the full drag range
  const arrayIndices = waferUtil.getBoxArrayIndicesFromCanvasCoords({
    startX,
    startY,
    endX,
    endY,
  });

  // Remove temporary dies before inserting real ones
  if (prevArrayIndices) {
    UtilityFunctions.removeTemporaryDiesForSelection(
      prevArrayIndices, startRow, startCol, rowDirection, colDirection, waferData,
    );
    prevArrayIndices = null;
  }

  // Call the insert die action with range
  waferUtil.performActionAndSendResponse({
    action: ActionOnWaferData.INSERT_DIE,
    config: {
      startRow: arrayIndices.startY,
      startCol: arrayIndices.startX,
      endRow: arrayIndices.endY,
      endCol: arrayIndices.endX,
    },
  });
};
